// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_UPDATE_PLAN,
} from './constants';

export function updatePlan(plan) {
  return {
    type: HOME_UPDATE_PLAN,
    data: plan
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_UPDATE_PLAN:
      return {
        ...state,
        plans:
        {
          ...state.plans,
          [action.data.id]: {...action.data, dirty: true}
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/updatePlan.js